import { Navigate, Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import path from 'routes/Path';
import Sidebar from 'layouts/Sidebar';
import MainHeader from 'layouts/Header/MainHeader';
import PageTitle from 'layouts/Header/PageTitle';

const Root = () => {
  const isToken = localStorage.getItem('token');
  if (!isToken) {
    return <Navigate to={`${path.SIGNIN}`} />;
  }

  return (
    <Layout className="min-h-screen">
      <Sidebar />
      <Layout className="mt-0">
        <MainHeader />
        <div className="pt-2 pb-5 px-7 bg-sub h-full flex flex-col">
          <PageTitle />
          <Outlet />
        </div>
      </Layout>
    </Layout>
  );
};

export default Root;
